/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import PopProductShipLotCreateDialog from "../dialogTypes/PopProductShipLotCreateDialog";

function PopProductShipLotCreateButton ( props ) {
    const {id, grid, schema, refresh, shipmentSelect, onSuccess, ...others} = props;
    const [open, setOpen] = useState(false);
    const {t} = useTranslation();
    
    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
    };

    return (
        <>
            <CreateRecordButtonLayout id={id+"append-button"} onClick={onOpen} {...others} />
            <PopProductShipLotCreateDialog
                id={id+"append-dialog"}
                title={t(`dialog.title.${schema.name}.create`)}
                grid={grid}
                schema={schema}
                shipmentSelect={shipmentSelect}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />
        </>
    );
}

export default PopProductShipLotCreateButton;

